/**
 * AdminServerLogPanel React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button/Button";

// Material UI icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RefreshIcon from '@material-ui/icons/Refresh';
import BugReportIcon from '@material-ui/icons/BugReport';
import InfoIcon from '@material-ui/icons/Info';

// application
import {fetchJSON, executeSimpleServerCommand} from "../../operations/communication";
import {
    REST_CALL_UPDATE_SERVER_LOG,
    REST_SERVER_BASE_URL
} from "../../config";


/**
 * Panel for admin page to show servcer log
 *
 * @author Jens Gruschel
 */
class AdminServerLogPanel extends React.Component {

    constructor(props) {
        super(props);
        this.serverLogArea = React.createRef();
    }

    state = {
        serverLog: undefined,
    };

    componentDidMount() {
        this.fetchServerLog();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // Scroll serverlog textarea to the bottom
        const serverLogArea = this.serverLogArea.current;
        if (serverLogArea) {
            serverLogArea.scrollTop = serverLogArea.scrollHeight;
        }
        // update log asynchronously
        if (this.state.serverLog === undefined) {
            this.fetchServerLog();
        }
    }

    render() {

        const { classes } = this.props;

        return <ExpansionPanel defaultExpanded={true}>

            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>Server-Log</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>

                <div className={classes.detailsPage}>
                    <div>
                        <IconButton onClick={() => {
                            this.fetchServerLog();
                        }}>
                            <RefreshIcon/>
                        </IconButton>

                        <span style={{float: "right"}}>
                            <Button
                                className={classes.button}
                                onClick={() => {
                                    this.props.executeSimpleServerCommand("setting debug log level", "GET", REST_SERVER_BASE_URL + "/logging/level/debug");
                                }}
                            ><BugReportIcon className={classes.leftIcon} />set debug level</Button>
                            <Button
                                className={classes.button}
                                onClick={() => {
                                    this.props.executeSimpleServerCommand("setting info log level", "GET", REST_SERVER_BASE_URL + "/logging/level/info");
                                }}
                            ><InfoIcon className={classes.leftIcon} />set info level</Button>
                        </span>
                    </div>

                    <textarea ref={this.serverLogArea} value={this.state.serverLog}
                        style={{width: "100%", height: "500px", fontFamily: "monospace"}} readOnly={true}
                    />

                    <a href={REST_SERVER_BASE_URL + "/logging/server.log"} target="_blank" rel="noopener noreferrer"><Typography>download log file</Typography></a>
                </div>
            </ExpansionPanelDetails>

        </ExpansionPanel>;
    }

    async fetchServerLog(maxbytes = 100 * 1024 * 1024) {

        try {
            const result = await fetchJSON(
                REST_SERVER_BASE_URL + REST_CALL_UPDATE_SERVER_LOG.path.replace("<maxbytes>", maxbytes), {
                    method: REST_CALL_UPDATE_SERVER_LOG.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + this.props.accessToken
                    }
                }
            );
            this.setState({serverLog: result.message});
        }
        catch (error) {
            this.setState({serverLog: error.message ? error.message : error});
        }
    }    
}

const styles = theme => ({
    detailsPage: {
        width: "100%"
    },
    button: {
        margin: theme.spacing.unit
    },
    leftIcon: {
        marginRight: theme.spacing.unit
    }
});

const mapStateToProps = state => {
    return {
        accessToken: state.authorization.accessToken
    };
};

export default connect(mapStateToProps, {executeSimpleServerCommand})(withStyles(styles)(AdminServerLogPanel));